export const CERTIFICAT_STATUS: {
  [propName:string]:{value:string,style:{color:string}}
} = {
  "APPLYING": {
    value: '证书申请中...',
    style: {color: 'blue'}
  },
  "APPLY_DEFEAT": {
    value: '申请证书失败',
    style: {color: 'red'}
  },
  "APPLY_SUCCESS": {
    value: '申请证书成功',
    style: {color: 'green'}
  },
  "NOT_APPLY": {
    value: '证书未申请',
    style: {color: 'red'}
  }
}

export const DEPLOY_STATUS: {
  [propName:string]:{value:string,style:{color:string}}
} = {
  "DEPLOYING": {
    value: 'CDN部署中...',
    style: { color: 'blue'}
  },
  "ADD_CDN_DEFEAT": {
    value: 'CDN部署证书失败',
    style: { color: 'red'}
  },
  "DEPLOY_DEFEAT": {
    value: 'CDN部署证书失败',
    style: { color: 'red'}
  },
  "DEPLOY_SUCCESS": {
    value: 'CDN部署成功',
    style: { color: 'green'}
  },
  "NOT_DEPLOY": {
    value: 'CDN未部署',
    style: { color: 'red'},
  }
}

